export const mapStyles = (state, option) => {

    const {neighborhoodStreets, pointsOfInterest} = state;

    return [
        {
            "elementType": 'labels', "stylers": [
                {
                    "visibility": option !== "RESET" ? option === "POI" ? neighborhoodStreets ? 'on' : 'off' : !neighborhoodStreets ? 'on' : 'off' : 'off'
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "all",
            "stylers": [
                {
                    "visibility": option !== "RESET" ? option === "POI" ? !pointsOfInterest ? 'on' : 'off' : pointsOfInterest ? 'on' : 'off' : 'off'
                }
            ]
        },

        {
            "featureType": "road",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "visibility": option !== "RESET" ? option === "POI" ? neighborhoodStreets ? 'on' : 'off' : !neighborhoodStreets ? 'on' : 'off' : 'off'
                }
            ]
        },
    ]
}